import {useAxios} from '@common/hooks';
import {
  BiologicalSexType,
  CityType,
  CountryType,
  EducationLevelType,
  EthnicityType,
  GenderType,
  IdentificationNumberTypeType,
  MaritalStatusType,
} from '@common/types';

export default {
  async getBiologicalSexesByCountryAsync(alphaCode2: string): Promise<BiologicalSexType[]> {
    const response = await useAxios().get<BiologicalSexType[]>(
      `/api/v1/base/geo/countries/${alphaCode2}/biologicalSexes`,
    );

    return response.data;
  },

  async getCitiesByCountryAsync(alphaCode2: string): Promise<CityType[]> {
    const response = await useAxios().get(
      `/api/v1/base/geo/countries/${alphaCode2}/cities`,
    );
    return (response.data as CityType[]).map(c => {
      c.divisionAndName = `${c.division} - ${c.name}`;
      return c;
    });
  },

  async getCountriesAsync(): Promise<CountryType[]> {
    const response = await useAxios().get(
      `/api/v1/base/geo/countries`,
    );
    return (response.data as CountryType[]).map(c => {
      c.alphaCode2AndName = `${c.alphaCode2} - ${c.name}`;
      return c;
    });
  },

  async getEducationLevelsByCountryAsync(alphaCode2: string): Promise<EducationLevelType[]> {
    const response = await useAxios().get<EducationLevelType[]>(
      `/api/v1/base/geo/countries/${alphaCode2}/educationLevels`,
    );

    return response.data;
  },

  async getEthnicitiesByCountryAsync(alphaCode2: string): Promise<EthnicityType[]> {
    const response = await useAxios().get<EthnicityType[]>(
      `/api/v1/base/geo/countries/${alphaCode2}/ethnicities`,
    );

    return response.data;
  },

  async getGendersByCountryAsync(alphaCode2: string): Promise<GenderType[]> {
    const response = await useAxios().get<GenderType[]>(
      `/api/v1/base/geo/countries/${alphaCode2}/genders`,
    );

    return response.data;
  },

  async getIdentificationNumberTypesByCountryAsync(alphaCode2: string): Promise<IdentificationNumberTypeType[]> {
    const response = await useAxios().get(
      `/api/v1/base/geo/countries/${alphaCode2}/identificationNumberTypes`,
    );
    return (response.data as IdentificationNumberTypeType[]).map(c => {
      c.codeAndName = `${c.code} - ${c.name}`;
      return c;
    });
  },

  async getMaritalStatusesByCountryAsync(alphaCode2: string): Promise<MaritalStatusType[]> {
    const response = await useAxios().get<MaritalStatusType[]>(
      `/api/v1/base/geo/countries/${alphaCode2}/maritalStatuses`,
    );

    return response.data;
  },
};